// Shared transition recipe for right-edge slide-over panels (performance
// pane, day-detail drawer, analytics filters). 500ms in / 400ms out with an
// ease-in-out cubic so panels accelerate from rest and settle into place.
//
// Requirements at the call site:
// - the Dialog must stay MOUNTED while closed (no `if (!open) return null`),
//   otherwise Headless UI skips the enter transition and drops the leave one;
// - pass `transition` to DialogBackdrop / DialogPanel.

export const SLIDE_OVER_BACKDROP_CLASS =
  'fixed inset-0 bg-black/30 dark:bg-black/60 transition-opacity data-[closed]:opacity-0 '
  + 'data-[enter]:duration-500 data-[enter]:ease-out data-[leave]:duration-[400ms] data-[leave]:ease-in';

// Compose with the panel's own layout/surface classes.
export const SLIDE_OVER_PANEL_TRANSITION_CLASS =
  'transition-transform data-[closed]:translate-x-full '
  + 'data-[enter]:duration-500 data-[enter]:ease-[cubic-bezier(0.65,0,0.35,1)] '
  + 'data-[leave]:duration-[400ms] data-[leave]:ease-[cubic-bezier(0.65,0,0.35,1)]';

// Side panels are viewport-fixed, so the padding Layout applies for the
// playground banner never reaches them and the banner (fixed, z-60) clips
// their header. Pin their top to the banner height instead; the variable is
// only set in the playground build, so this is a no-op everywhere else.
// Apply to the panel itself (or the fixed wrapper that positions it), not to
// the backdrop, which should keep covering the whole viewport.
export const SLIDE_OVER_TOP_OFFSET_STYLE = { top: 'var(--playground-banner-height, 0px)' };
